import NewsletterTwentySixContainer from "./container/NewsletterTwentySixContainer";
export default NewsletterTwentySixContainer;
